import React, { useState } from "react";
import { useFetchPastOrdersQuery } from "../store/apis/order.api";
import { PastOrder } from "../types";
import Skeleton from "../components/common/Skeleton";
import Pagination from "../components/common/Pagination";
import { useNavigate } from "react-router-dom";

const OrdersHistory = () => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const navigate = useNavigate();

  const { data, isFetching } = useFetchPastOrdersQuery({ page, perPage });

  const handleOrderClick = (orderId: string) => {
    navigate(`/history/${orderId}`);
  };

  const renderedOrders = data?.orders.map((order: PastOrder) => (
    <div
      key={order._id}
      onClick={() => handleOrderClick(order._id)}
      className="bg-white p-4 rounded-lg shadow-md mb-4 cursor-pointer hover:shadow-lg transition-shadow border border-gray-100"
    >
      <div className="flex justify-between items-start mb-2">
        <div>
          <span className="font-bold text-lg text-primary">
            #{order.displayId}
          </span>
          <span className="ml-2 text-sm text-gray-500">
            • {order.items} article{order.items > 1 ? "s" : ""}
          </span>
        </div>
        <div className="text-right">
          <div className="font-bold text-lg">
            {order.paymentInfo.totalPrice.text}
          </div>
          <div className="text-xs text-gray-400 capitalize">
            {order.createdAt}
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-100">
        <div className="flex items-center">
          <span
            className={`px-2 py-1 rounded text-xs font-semibold capitalize ${
              order.orderType === "delivery"
                ? "bg-blue-100 text-blue-800"
                : "bg-green-100 text-green-800"
            }`}
          >
            {order.orderType === "delivery" ? "Livraison" : "À emporter"}
          </span>
        </div>
        <span className="text-primary text-sm font-medium hover:underline">
          Voir détails &rarr;
        </span>
      </div>
    </div>
  ));

  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">
        Historique des commandes
      </h1>

      {isFetching ? (
        <div className="space-y-4">
          <Skeleton
            className="h-24 w-full rounded-lg"
            times={3}
          />
        </div>
      ) : (
        <>
          {renderedOrders && renderedOrders.length > 0 ? (
            <div className="space-y-4">{renderedOrders}</div>
          ) : (
            <div className="text-center py-12 bg-gray-50 rounded-lg">
              <p className="text-gray-500 text-lg">
                Aucune commande passée pour le moment.
              </p>
            </div>
          )}

          {data?.paginationInfo && data.paginationInfo.count > 0 && (
            <div className="mt-8">
              <Pagination
                paginationInfo={data.paginationInfo}
                setPage={setPage}
                setPerPage={setPerPage}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default OrdersHistory;
